import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { useTab } from '@components/Tabs/Tabs'
import { usePagination } from '@hooks/usePagination'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import { useEbookAction } from '@hooks/ebook/useEbookAction'
import { BookEnum } from '@interfaces/BookEnum'
import { EbookTabProps, WithEbookTabProps, SearchType } from './interface'

export function withEbookTab(Component: React.FC<EbookTabProps>) {
  function WithEbookTab({ userId }: WithEbookTabProps) {
    const penNameClient = usePenNameAction()
    const ebookClient = useEbookAction()
    const { handleTabNameChange } = useTab()

    const { page, perpage, pageChange, perpageChange } = usePagination()
    const [bookType, setBookType] = useState<BookEnum | null>(null)
    const [searchParam, setSearchParam] = useState<SearchType>({
      bookType: null,
      penNameId: null,
    })

    const { data: ebookList, isLoading } = useQuery(
      ['search-ebook-profile', userId, searchParam, page, perpage],
      () =>
        ebookClient.searchWritingEbookProfile({
          ...searchParam,
          userId,
          page,
          limitPerPage: perpage,
        }),
      {
        enabled: !!userId,
        onSuccess: response => {
          if (response) {
            handleTabNameChange(
              'ebook',
              `อีบุ๊ก (${response.totalEbook.toLocaleString()})`
            )
          }
        },
      }
    )

    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options', userId],
      () => penNameClient.getPenNameOptions(userId),
      { enabled: !!userId }
    )

    function handleBookTypeChange(value: BookEnum | null) {
      pageChange(1)
      setBookType(value)
      setSearchParam(prev => ({ ...prev, bookType: value && [value] }))
    }

    function handlePenNameChange(penNameId: number) {
      pageChange(1)
      setSearchParam(prev => ({ ...prev, penNameId }))
    }

    function handlePaginationChange(newPage: number) {
      pageChange(newPage)
    }

    const componentProps = {
      datas: ebookList?.data ?? [],
      isLoading,
      bookType,
      searchParam,
      penNameOptions,
      page,
      perpage,
      total: ebookList?.total ?? 0,
      perpageChange,
      handlePaginationChange,
      handleBookTypeChange,
      handlePenNameChange,
    }

    return <Component {...componentProps} />
  }

  return WithEbookTab
}
